import { formatNumberForLocale } from '@vend/utilities'
import { round } from 'vend-number'
import { useRetailerSettingsManager } from '../../ng-compat/hooks'

export const NOT_APPLICABLE = '-'
export const DECIMAL_PLACES = 2

export const useFormatClosureNumber = () => {
  const retailer = useRetailerSettingsManager().get()

  return (value: string | number) => {
    if (value === NOT_APPLICABLE) {
      return NOT_APPLICABLE
    }
    return formatNumberForLocale(
      round(value, DECIMAL_PLACES),
      retailer.culture,
      {
        style: 'decimal',
        maximumFractionDigits: DECIMAL_PLACES,
        minimumFractionDigits: DECIMAL_PLACES,
        useGrouping: false,
      }
    )
  }
}
